import Calendar from './Calendar.component';
export type { CalendarProps } from './Calendar.component';

export default Calendar;
